import { Message, OpenCodeSession, Part } from "../models/Agent";
import client from "./axios";

const agentsUrl = `${window.__env.GATEWAY_URL}/v1/agents`;
const guideUrl = `${window.__env.GATEWAY_URL}/v1/guide`;

export interface AgentGenerationResponse {
  id: string;
  messages: AgentMessage[];
  status: { state: string };
}

export interface GenerationResponseText {
  Description: string;
  Tags?: string[];
}

interface AgentMessage {
  parts: { text: string }[];
  role: string;
}

interface GenerationBodyDetails {
  id: string;
  message: AgentMessage;
}

export interface AgentGenerationBody {
  redisNamespace: string;
  redisKey: string;
  details: GenerationBodyDetails;
}

export interface OpenCodeMessageResponse {
  info: Message;
  parts: Part[];
}

export const Agents = {
  generate: (body: AgentGenerationBody) => client.post<AgentGenerationResponse>(agentsUrl, body),
  sendMessage: (agentBaseUrl: string, message: any, signal?: AbortSignal) => client.post<any>(`${agentBaseUrl}/chat/completions`, message, { signal }),
  createOpenCodeSession: (agentBaseUrl: string) => client.post<OpenCodeSession>(`${agentBaseUrl}/session`),
  sendOpenCodeMessage: (agentBaseUrl: string, sessionId: string, body: any) => client.post<OpenCodeMessageResponse>(`${agentBaseUrl}/session/${sessionId}/prompt_async`, body),
  abortOpenCodeSession: (agentBaseUrl: string, sessionId: string) => client.post<boolean>(`${agentBaseUrl}/session/${sessionId}/abort`),
  getSessionMessages: (agentBaseUrl: string, chatSession: string, params?: URLSearchParams) => client.get<OpenCodeMessageResponse[]>(`${agentBaseUrl}/session/${chatSession}/message`, { params }),
  listenOpenCode: (agentStreamingUrl: string, onMessage: (evt: MessageEvent<any>) => void, onError?: (evt: Event) => void, params?: URLSearchParams) => {
    const fullUrl = `${agentStreamingUrl}${params && params.size > 0 ? `?${params.toString()}` : ''}`;
    const source = new EventSource(fullUrl);
    source.addEventListener('message', onMessage, false);
    if (onError) source.addEventListener('error', onError, false);
    return source;
  },
  putOpenCodeSession: (sessionId: string) => client.put(`${guideUrl}/session/${sessionId}`, {}),
  deleteOpenCodeSession: (sessionId: string) => client.delete(`${guideUrl}/session/${sessionId}`),
}